import styled, { css } from "styled-components";
import { activeColor, color, onHover, typeStyle, units, variant } from "@m/alchemy-theme";
import { darken } from "polished";
function toBoolean(value) {
    if (typeof value === "boolean") {
        return value;
    }
    return value === "true";
}
export const ActionListSubGroup = styled.ul `
  + ul {
    border-top: 12px solid ${color("line")};
  }
  ${({ hasIcons, layout }) => hasIcons &&
    layout === "start" &&
    css `
      li > * {
        padding-left: ${units(4)};
        text-align: left;
      }

      ul {
        padding-left: 0;
      }
    `};

  ${({ hasIcons, layout }) => hasIcons &&
    layout === "end" &&
    css `
      li > * {
        padding-right: ${units(4)};
        text-align: right;
      }

      ul {
        padding-right: 0;
      }
    `};
`;
export const ActionItem = styled.li `
  ${(props) => props.hasChildren &&
    !props.isLastItem &&
    `
      border-bottom: 1px solid ${color("line")(props)};
  `};
`;
export const ActionButton = styled.button `
  ${typeStyle("bodyS")};
  appearance: none;
  background: none;
  border: 0;
  display: block;
  margin: 0;
  padding: ${units(1)} ${units(1.5)};
  position: relative;
  text-align: ${({ layout }) => (layout === "end" ? "right" : "left")};
  width: 100%;
  opacity: ${({ "aria-disabled": disabled }) => (toBoolean(disabled) ? 0.35 : 1)};
  color: ${color("typeBody")};

  ${({ hasIcon, layout }) => hasIcon &&
    layout === "start" &&
    css `
      svg {
        color: ${color("typeMeta")};
        position: absolute;
        top: ${units(1.25)};
        left: ${units(1.25)};
      }
    `};

  ${({ hasIcon, layout }) => hasIcon &&
    layout === "end" &&
    css `
      svg {
        color: ${color("typeMeta")};
        position: absolute;
        top: ${units(1.25)};
        right: ${units(1.25)};
      }
    `};

  ${({ onClick }) => onClick &&
    css `
      cursor: ${({ "aria-disabled": disabled }) => (toBoolean(disabled) ? "not-allowed" : "pointer")};

      ${onHover(css `
        background-color: ${({ "aria-disabled": disabled }) => (toBoolean(disabled) ? "transparent" : color("hint"))};

        svg {
          color: ${color("base")};
        }
      `)}

      &:active:not([aria-disabled="true"]) {
        color: ${activeColor("base")};
        background-color: ${(props) => darken(0.01, color("hint")(props))};

        svg {
          color: ${activeColor("base")};
        }
      }
    `};

  ${variant("as", { a: `text-decoration: none;`, h4: `font-weight: bold; pointer-events: none;` })}
`;
